import axios from 'axios';

// let baseURL ='http://192.168.110.18:9003';
let baseURL ='http://39.107.86.41:9003';

const instance = axios.create({
  baseURL: baseURL,
  timeout: 10000,
});

const instance2 = axios.create({
  baseURL: baseURL,
  timeout: 10000,
  responseType:'blob',
});

export {baseURL}
//==============================================院校信息===============================================================//
//头部 的信息
export function getCollegeInfo(url: any, params: any) {
  return instance.get(url, params);
}

//左半部分 院校简介、硕博点介绍、双一流建设学科
export function getLeft123(url: any, params: any) {
  return instance.get(url, params);
}

//左半部分 专业设置
export function getLeft4(url: any, params: any) {
  return instance.get(url, params);
}

//左半部分 硕博点介绍
export function getLeft6(url: any, params: any) {
  return instance.get(url, params);
}

//左半部分 保研率详情
export function getLeft7(url: any, params: any) {
  return instance.get(url, params);
}

//左半部分 学科评估
export function getLeft5(url: any, params: any) {
  return instance.get(url, params);
}

//右半部分 高校排行
export function getRight1(url: any, params: any) {
  return instance.get(url, params);
}

//右半部分 院校资讯
export function getRight3(url: any, params: any) {
  return instance.get(url, params);
}

//右半部分 联系地址
export function getRight4(url: any, params: any) {
  return instance.get(url, params);
}

//获取院校录取规则
export function collegeGetRecruitRule(url: any, params: any) {
  return instance.get(url, params);
}


//======================================================中转页面=======================================================//
//获取横向菜单栏的item
export function majorsGetLevelList(url: any) {
  return instance.get(url);
}

//菜单栏 点击 学科门类 返回一级学科
export function getSubject(url: any, params: any) {
  return instance.get(url, params);
}

//菜单栏 点击 一级学科 返回具体专业
export function getMajor(url: any, params: any) {
  return instance.get(url, params);
}

//======================================================专业搜索页面=======================================================//
//根据专业名称模糊查询
export function majorsFindMajorByName(url: any, params: any) {
  return instance.get(url, params);
}

//==============================================专业信息页面===============================================================//
//获取院校名臣
export function masterGetCollegeName(url: any, params: any) {
  return instance.get(url, params);
}

//刚进页面 传值
export function getMajorInfo(url: any, params: any) {
  return instance.get(url, params);
}

//获取 专业排行榜列表
export function majorsGetMajorRanksType(url: any) {
  return instance.get(url);
}
//根据排行榜列表获取排行榜信息
export function majorsGetMajorRanks(url: any, params: any) {
  return instance.get(url, params);
}


// //专业就业率排行榜
// export function getMajorEmploymentRate(url: any, params: any) {
//   return instance.get(url, params);
// }

//================专业（类）指标排行=============//
export function getMajorTargetRank(url: any,params:any) {
  return instance.get(url,params);
}

//下载PDF
export function downloadMajorTargetRank(url: any,params: any) {
  return instance2.get(url,params);
}

//和佳美改版，分本科、职本、专科显示的 获取专业信息 接口
export function majorsGetMajorsDetailV2(url: any, params: any) {
  return instance.get(url, params);
}




//==============================================学科门类页面=======================================================//
//刚进页面返回值
export function getDisciplineInfo(url: any, params: any) {
  return instance.get(url, params);
}

//====================================================首页============================================================//
//刚进页面返回 头部 右方 第一个下拉框的值
export function getSelectSerachProvince(url: any) {
  return instance.get(url);
}

//点击 头部左半部分 的搜索
export function getCollegeInfoByInput(url: any,params:any) {
  return instance.get(url,params);
}

//选中头部右方第一个下拉框 返回的值
export function getSelectSerachCity(url: any,params:any) {
  return instance.get(url,params);
}

//点击 头部 右方 按城市查询 按钮
export function getCollegeInfoBySelect(url: any,params:any) {
  return instance.get(url,params);
}

//点击 头部 右方 按省份（城市为：所有）查询 按钮
export function getCollegeInfoBySelect2(url: any,params:any) {
  return instance.get(url,params);
}

//点击头部右方按（省份为：所有)（城市为：所有）查询 按钮
export function searchGetAllColleges(url: any) {
  return instance.get(url);
}

//联查找所有院校信息（佳美优化版）
export function searchGetColleges(url: any,params:any) {
  return instance.get(url,params);
}

//============================================= =======提前批============================================================//
// 获取左边的菜单栏数据
export function getMenuInfo(url: any,params:any) {
  return instance.get(url,params);
}

// 获取右边的表格数据
export function getTableInfo(url: any,params:any) {
  return instance.get(url,params);
}

// 通过搜索院校名称 获取右边的表格数据
export function getTableInfoBySearch(url: any,params:any) {
  return instance.get(url,params);
}

// 点击每年的 查看 按钮
export function getPreviousData(url: any,params:any) {
  return instance.get(url,params);
}

// 点击 菜单栏  获取返回数据的总页数
export function getTotalPage(url: any,params:any) {
  return instance.get(url,params);
}

//================================================本硕衔接查询================================================//
//根据本科专业查询可考的硕士专业
export function masterUndergraduateMaster(url: any,params:any) {
  return instance.get(url,params);
}

//根据本科专业代码获取本科专业名称
export function masterGetMajorName(url: any,params:any) {
  return instance.get(url,params);
}


//省份字典
export function masterGetProvince(url: any) {
  return instance.get(url);
}

//学校标签字典
export function masterGetUniversityFeatures(url: any) {
  return instance.get(url);
}

//研究生专业开设的院校查询
export function masterMasterUniversity(url: any,params:any) {
  return instance.get(url,params);
}

//根据硕士专业查找能报考的本科专业
export function masterMasterUndergraduate(url: any,params:any) {
  return instance.get(url,params);
}
//================================================职业查询首页================================================//
//查询行业列表
export function getIndustryList(url: any) {
  return instance.get(url);
}

//根据行业查询职业类别列表
export function getOccTypeByIndustry(url: any,params:any) {
  return instance.get(url,params);
}

//查询职业列表
export function getOccList(url: any,params:any) {
  return instance.get(url,params);
}

//查询职业概况
export function getOccInfo(url: any,params:any) {
  return instance.get(url,params);
}

//查询职业相关专业
export function getOccMajor(url: any,params:any) {
  return instance.get(url,params);
}
